import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LayoutState } from '../../core/models/layout';

export const selectLayoutState = createFeatureSelector<LayoutState>('layout');

export const selectLoading = createSelector(
  selectLayoutState,
  (state: LayoutState) => state.loading
);

export const selectTheme = createSelector(
  selectLayoutState,
  (state: LayoutState) => state.darkMode
);

export const selectedTitle = createSelector(selectLayoutState, (state: LayoutState) => state.title);

export const selectSidenavMode = createSelector(selectLayoutState, (state: LayoutState) => state.toggleSidenav);
